export default class KeyBoard {
  constructor() {
    // console.log('Keys called');
  }
}
